// import React, { useState, useEffect } from 'react';
// import defaultIcon from "../../../../assets/Website Tracking/DefaultIconFor_Websites.png";
// import defaultIconWithPlus from "../../../../assets/web-plus.png";
// import axios from 'axios';
// import sourceUrl from '../../../../api/Source.api';
// import { Box, Typography, Button, Tooltip } from '@mui/material';
// import { useWorkspace } from "../../../../contexts/WorkspaceContext";
// import AddIcon from '@mui/icons-material/Add';
// import CircleIcon from '@mui/icons-material/Circle';
// import TrackWebsiteModal from './TrackWebsiteModal';


// const formatDate = (dateString) => {
//     const date = new Date(dateString);
//     const options = { month: 'long', day: 'numeric' };
//     return date.toLocaleDateString(undefined, options);
//   };



// const WebsiteListingPage = ({ website }) => {
//   // const [website, setWebSite] = useState(website || []);
//   const token = localStorage.getItem('token');
//   const {setOpenWebsiteTrackModal,setCurrentWebsiteLinkedId,setSelectedWeb} = useWorkspace();
//   // const [addWebClicked, setAddWebClicked] = useState(false);

// //   ==================== start  Default component if there is no websites added yet =================================

//   const DefaultScreenIfNoWebsites = () => {
//     return(
//         <Box sx={{width:'100%',maxWidth:'312px',height:'229px',margin:'auto',display:'flex',flexDirection:'column',justifyContent:'space-between',alignItems:'center'}}>
//             <Box sx={{ width: '60px', height: '60px', display: 'flex', alignItems: 'center' }}>
//                 <img src={defaultIconWithPlus} alt="website" style={{ width: '100%', height: '100%', display: 'block' }} />
//             </Box>
//             <Typography sx={{fontSize:'16px',fontWeight:600}}>Start by adding a website</Typography>
//             <Typography sx={{fontSize:'14px',fontWeight:400}}>You have not added any websites to track yet. Get started by adding a website.</Typography>
//             <Button
//               onClick={() => { setOpenWebsiteTrackModal(true) }}
//               sx={{
//                 backgroundColor: 'white',
//                 border: 'none',
//                 padding: 0,
//                 margin: 0,
//                 textTransform: 'none',
//                 color: '#17182C',
//                 '&:hover': { backgroundColor: 'transparent',color:'rgba(255,255,255,0.8)' },
//                 width:'164px',
//                 height:'40px',
//                 fontWeight:600,
//                 fontFamily:'inter'
//               }}
//             >
//               <AddIcon sx={{width:'20px',height:'20px',marginRight:'8px'}} />
//               Add website
//             </Button>
//         </Box>
//     )
// }

// //   ==================== end  Default component if there is no websites added yet =================================

//   // useEffect(() => {
//   //   fetchWebsites();
//   // }, [addWebClicked]);

//   // const fetchWebsites = async () => {
//   //   try {
//   //     const res = await axios.get(`${sourceUrl}/websiteTracking/listAll`, {
//   //       headers: {
//   //         Authorization: `Bearer ${token}`,
//   //         "Content-Type": "application/json",
//   //       },
//   //     });
//   //     const sortedData = res.data.data.sort((a, b) => {
//   //       if (a.notifications === b.notifications) return 0;
//   //       return a.notifications ? -1 : 1;
//   //     });
//   //     setWebSite(sortedData);
//   //   } catch (error) {
//   //     console.error(error);
//   //   }
//   // };

//   const getSingleWebTrackDetails = async (id) => {
//     setCurrentWebsiteLinkedId(id.linkId)
//     setSelectedWeb(id.displayName);
//     // try {
//     //   const res = await axios.get(`${sourceUrl}/websiteTracking/get/${id}`,{
//     //     headers:{
//     //       "Authorization":`Bearer ${token}`,
//     //       "Content-Type":"application/json"
//     //     }
//     //   })
//     //   const responseData = await res.json();
//     //   return responseData.data ;
//     // } catch (error) {
//     //   console.log(error)
//     // }
//   }

//   // const handleAddWebClicked = () => {
//   //   setAddWebClicked(!addWebClicked);
//   // };


  

//   return (
//     <Box sx={{paddingTop: '60px', 
//         display: 'flex', 
//         justifyContent: 'center', 
//         alignItems: 'center', 
//         textAlign: 'center', 
//         width: '100%'}}>
//       <Box sx={{ fontWeight: 500}}>
//         {/* <Typography variant="h5" sx={{ marginBottom: '48px', fontSize: '24px', textTransform: 'none',gap:'20px'}}>Track sites with ModalX 
//         <Button
//             sx={{
//                 textTransform: 'none',
//                 padding: '4px 8px',
//                 bgcolor: '#E6E0E9',
//                 fontSize: '12px',
//                 fontWeight: '500',
//                 color: '#17182C',
//                 '&:hover': {
//                 bgcolor: '#E6E0E9', // Keeps background color the same on hover
//                 color: '#17182C', // Keeps text color the same on hover
                
//                 },
//             }}
//             >
//             Beta
//         </Button>
//         </Typography> */}
//         <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '20px', marginBottom: '48px' }}>

//             <Typography 
//              sx={{ 
//               fontFamily : 'Inter',
//               fontSize: '24px',
//               fontWeight: '500',
//               lineHeight: '24px',
//               letterSpacing: '0.10000000149011612px',
//               color : '#FFFFFF',
//                }}>
//             Track sites with ModalX
//             </Typography>
//             <Button
//             sx={{
//                 textTransform: 'none',
//                 padding: '4px 8px',
//                 bgcolor: '#E6E0E9',
//                 fontSize: '12px',
//                 fontWeight: '500',
//                 color: '#17182C',
//                 '&:hover': {
//                 bgcolor: '#E6E0E9', // Keeps background color the same on hover
//                 color: '#17182C',    // Keeps text color the same on hover
//                 },
//             }}
//             >
//             Beta
//             </Button>
//         </Box>

//         <Box sx={{ maxWidth: '688px', minHeight: '88px', fontSize: '16px', textTransform: 'none',margin:'auto',textAlign:'start'}}>
//           <Typography sx={{ marginBottom: '18px',
//              textTransform: 'none',
//              fontFamily : 'Inter',
//              fontWeight  : 400,
//              fontSize : '16px',
//              textAlign : 'center',
//              color : '#FFFFFF',
//               }}>
//             Stay up to date with the latest updates and information on any webpage.
//           </Typography>
//           <Typography
//            sx={{ textTransform: 'none',
//                   fontFamily : 'Inter',
//                   fontWeight  : 400,
//                   fontSize : '16px',
//                   textAlign : 'center',
//                   color : '#FFFFFF',
//            }}>
//             Give ModalX an URL to track, and you will get notified whenever there is an update on the site, along with a summary of the update!
//           </Typography>
//         </Box>
//         <Box sx={{marginBottom: '40px',marginTop: '60px', }}>
//           <Box
//             sx={{
//               width: '688px',
//               height: '40px',
//               display: 'flex',
//               justifyContent: 'space-between',
//               alignItems: 'center',
//               paddingBottom: '20px',
//               borderBottom: '1px solid rgba(255,255,255,0.6)',
              
//               textTransform: 'none',margin:'auto'
//             }}
//           >
//             <Typography sx={{ 
//               margin: 0,
//               textTransform: 'none',
//               fontfontFamily : 'Inter',
//               fontSize : '16px',
//               fontWeight : 400,
//               color : '#FFFFFF',
               
//              }}>Your sites</Typography>
//             <Button
//               onClick={() => { setOpenWebsiteTrackModal(true) }}
//               sx={{
//                 backgroundColor: 'transparent',
//                 border: 'none',
//                 padding: 0,
//                 margin: 0,
//                 textTransform: 'none',
//                 color: 'rgba(255,255,255,1)',
//                 '&:hover': { backgroundColor: 'transparent',color:'rgba(255,255,255,0.8)' },
//               }}
//             >
//               <AddIcon sx={{width:'20px',height:'20px',marginRight:'8px'}} />
//               <Typography sx={{
//                 fontFamily : 'Inter',
//                 fontSize : '16px',
//                 fontWeight : 600,
//                 // color : '#FFFFFF',
//               }}>Add website</Typography>
             
//             </Button>
//           </Box>
//         </Box>
//         <Box sx={{ maxHeight: '300px', overflowY: 'auto',maxWidth: '688px', }}>
//           {website.length === 0 ? <DefaultScreenIfNoWebsites /> : website.map((ele, index) => (
//             <Button
//               key={index}
//               sx={{
//                 width: '100%',
//                 maxWidth: '688px',
//                 height: '75px',
//                 borderRadius: '8px',
//                 border: '1px solid rgba(255,255,255,0.2)',
//                 backgroundColor: 'transparent',
//                 marginBottom: '16px',
//                 textTransform: 'none',
//                 '&:hover': { backgroundColor: 'transparent' }
//               }}
//               onClick={() => getSingleWebTrackDetails(ele)}
//             >
//               <Box sx={{ width: '100%', height: '100%', padding: '16px', display: 'flex',  alignItems: 'center' }}>
//                 <Box sx={{display:"flex", gap:"16px", width:"480px"}}>
//                 <Box sx={{ width: '40px', height: '40px', display: 'flex', alignItems: 'center' }}>
//                   <img src={ele?.websiteLogoUrl?.length > 0 ? ele.websiteLogoUrl : defaultIcon} alt="website" style={{ width: '100%', height: '100%', display: 'block' }} />
//                 </Box>
//                 <Box sx={{ fontSize: '16px', display: 'flex', flexDirection: 'column', height: '43px', textAlign: 'start', textTransform: 'none' }}>
//                     {ele?.displayName?.length > 0 && (
//                         <Tooltip title={ele.displayName} placement="top">
//                             <Typography sx={{ marginBottom: '0px', textTransform: 'none', color: 'rgba(255,255,255,1)' }}>
//                             {ele.displayName.length > 50 ? `${ele.displayName.substring(0, 50)}...` : ele.displayName}
//                             </Typography>
//                         </Tooltip>
//                     )}
//                   {ele?.websiteLink?.length > 0 && (
//                     <Typography sx={{ fontSize: '14px', color: 'rgba(255,255,255,0.8)', textTransform: 'none' }}>
//                       {ele?.websiteLink?.length > 50 ? `${ele?.websiteLink?.substring(0, 50)}...` : ele?.websiteLink}
//                     </Typography>
//                   )}
//                 </Box>
//                 </Box>
//                 <Box
//                     sx={{
//                         maxWidth: '158px',
//                         height: '14px',
//                         fontSize: '12px',
//                         textTransform: 'none',
//                         color: 'rgba(255,255,255,1)',
//                         display: 'flex',
//                         alignItems: 'center', 
//                         textAlign:"start",
//                         justifyContent:"flex-start"
//                     }}
//                     >
//                     <Typography sx={{ textTransform: 'none', fontSize: '12px',paddingRight:ele?.notifications === false && '12px' }}>
//                         {`Updated ${formatDate(ele.updatedAt)}`}
//                     </Typography>
//                     {ele?.notifications === true && <CircleIcon sx={{ color: '#F6BE6B', width: '12px', height: '12px', marginLeft: '4px' }} />}
//                 </Box>
//               </Box>
//             </Button>
//           ))}
//         </Box>
//       </Box>
//       {/* <TrackWebsiteModal
//         websites={website}
//         onAddWebClicked={handleAddWebClicked}
//       /> */}
//     </Box>
//   );
// };

// export default WebsiteListingPage;


//===================================================Shaban Khan Code start here with mobile===================================

import React, { useState, useEffect, useRef } from 'react';
import defaultIcon from "../../../../assets/Website Tracking/DefaultIconFor_Websites.png";
import defaultIconWithPlus from "../../../../assets/web-plus.png";
import axios from 'axios';
import sourceUrl from '../../../../api/Source.api';
import { Box, Typography, Button, Tooltip, FormControlLabel } from '@mui/material';
import { useWorkspace } from "../../../../contexts/WorkspaceContext";
import AddIcon from '@mui/icons-material/Add';
import CircleIcon from '@mui/icons-material/Circle';
import TrackWebsiteModal from './TrackWebsiteModal';
import { useMediaQuery } from 'react-responsive';
import WarRoomHeaderForMobileResponsive from '../../mobileResponsive/WarRoomHeaderForMobileResponsive';
import { ToggleSwitch } from '../../../Common_Components/ToggleSwitch';
import CommonToast from '../../../Common_Components/CommonToast';
import { useNavigate } from "react-router-dom";
import CircularLoader from './CircularLoader';



const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = { month: 'long', day: 'numeric' };
    return date.toLocaleDateString(undefined, options);
  };



const WebsiteListingPage = ({ website,updateWebList }) => {
  // const [website, setWebSite] = useState(website || []);
  const isUnder992px = useMediaQuery({ maxWidth:992});
  const token = localStorage.getItem('token');
  const {setOpenWebsiteTrackModal,setCurrentWebsiteLinkedId,setSelectedWeb, openWebsiteTrackModal,webTrackingWebsiteLoading,subscribe} = useWorkspace();
  // const [addWebClicked, setAddWebClicked] = useState(false);
  // const [openCommanModalAfterWebsiteSubmit,setOpenCommanModalAfterWebsiteSubmit] = useState(false);
  const [invokeNotificationToast,setInvokeNotificationToast] = useState(false);
  const [notifMessage,setNotifMessage] = useState('');
  const [open,setOpen] = useState(false);
  const [iconType,setIconType] = useState(null);
  const scrollableRef = useRef(null);
  const navigate = useNavigate();
  const [loadingState, setLoadingState] = useState(null);

  useEffect(() => {
    const handleWheel = (event) => {
      if (scrollableRef.current) {
        scrollableRef.current.scrollTop += event.deltaY;
        event.preventDefault(); // Prevent default page scrolling
      }
    };

    window.addEventListener('wheel', handleWheel, { passive: false });
    return () => {
      window.removeEventListener('wheel', handleWheel);
    };
  }, []);

  const handleNewWebsiteAddButtonClick = () =>{
    if(!subscribe){
      setNotifMessage('Upgrade to unlock Website Tracking!')
      setIconType("error")
      setOpen(true)
      return
    }
    if(website.length < 15){
      setOpenWebsiteTrackModal(true)
    }else{
      setNotifMessage('Your list is full! Remove a site to add a new one.')
      setInvokeNotificationToast(true)
    }
  }

  const handleCloseToastalert = () =>{
      setOpen(false)
  }

const handleCloseToast = () => {
  setInvokeNotificationToast(false);
};


//   ==================== start  Default component if there is no websites added yet =================================

  const DefaultScreenIfNoWebsites = () => {
    return(
        <Box sx={{width:'100%',maxWidth:'312px',height:'229px',margin:'auto',display:'flex',flexDirection:'column',justifyContent:'space-between',alignItems:'center'}}>
            <Box sx={{ width: '60px', height: '60px', display: 'flex', alignItems: 'center' }}>
                <img src={defaultIconWithPlus} alt="website" style={{ width: '100%', height: '100%', display: 'block' }} />
            </Box>
            <Typography sx={{fontSize:'16px',fontWeight:600}}>Start by adding a website</Typography>
            <Typography sx={{fontSize:'14px',fontWeight:400}}>You have not added any websites to track yet. Get started by adding a website.</Typography>
            <Button
              onClick={()=>{setOpenWebsiteTrackModal(true)}}
              sx={{
                backgroundColor: 'white',
                border: 'none',
                padding: 0,
                margin: 0,
                textTransform: 'none',
                color: '#17182C',
                '&:hover': { backgroundColor: 'transparent',color:'rgba(255,255,255,0.8)' },
                width:'164px',
                height:'40px',
                fontWeight:600,
                fontFamily:'inter'
              }}
            >
              <AddIcon sx={{width:'20px',height:'20px',marginRight:'8px'}} />
              Add website
            </Button>
        </Box>
    )
}

//   ==================== end  Default component if there is no websites added yet =================================

  // useEffect(() => {
  //   fetchWebsites();
  // }, [addWebClicked]);

  // const fetchWebsites = async () => {
  //   try {
  //     const res = await axios.get(`${sourceUrl}/websiteTracking/listAll`, {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //         "Content-Type": "application/json",
  //       },
  //     });
  //     const sortedData = res.data.data.sort((a, b) => {
  //       if (a.notifications === b.notifications) return 0;
  //       return a.notifications ? -1 : 1;
  //     });
  //     setWebSite(sortedData);
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };

  const getSingleWebTrackDetails = async (id) => {
    setCurrentWebsiteLinkedId(id.websiteId)
    setSelectedWeb(id.displayName);
    navigate(`/workspace/trackwithmodalx/${id.websiteId}`)
    // try {
    //   const res = await axios.get(`${sourceUrl}/websiteTracking/get/${id}`,{
    //     headers:{
    //       "Authorization":`Bearer ${token}`,
    //       "Content-Type":"application/json"
    //     }
    //   })
    //   const responseData = await res.json();
    //   return responseData.data ;
    // } catch (error) {
    //   console.log(error)
    // }
  }

  // const handleAddWebClicked = () => {
  //   setAddWebClicked(!addWebClicked);
  // };

  const handleEnable = async (ele) => {
    setLoadingState(ele.websiteId);
    try {
        const res = await axios.put(`${sourceUrl}/v1/websiteTrackings/${ele?.websiteId}`, {
          "websiteId": ele?.websiteId,
          "websiteLink": ele?.websiteLink,
          "displayName": ele?.displayName,
          "frequencyInMins": ele?.frequencyInMins,
          "isDisabled": false,
          "isDefault": ele?.isDefault,
          "addedAt": ele?.addedAt
        }, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });
        
        if (res.status) {
            console.log("Enable API call succeeded.");
            setLoadingState(null); // Clear the loading state
        }
    } catch (error) {
        if(error?.response?.data){
          setNotifMessage(`Failed to enable tracking for "${ele?.displayName}". Please try again.`);
          setInvokeNotificationToast(true);
        }
        console.error("Failed to update status:", error);
    }
    finally {
      const updatedWebsites = website.map((site) =>
        site.websiteId === ele.websiteId
          ? { ...site, isDisabled: false } // Assuming successful enable
          : site
      );
      updateWebList(updatedWebsites); // Update the state in parent
      setLoadingState(null); // Clear the loading state
  }
    // finally {
    //   updateWebList();
    // }
};

const handleDisable = async (ele) => {
  setLoadingState(ele.websiteId);
    try {
        const res = await axios.put(`${sourceUrl}/v1/websiteTrackings/${ele?.websiteId}`, {
          "websiteId": ele?.websiteId,
          "websiteLink": ele?.websiteLink,
          "displayName": ele?.displayName,
          "frequencyInMins": ele?.frequencyInMins,
          "isDisabled": true,
          "isDefault": ele?.isDefault,
          "addedAt": ele?.addedAt
        }, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });
        
        if (res.status) {
            console.log("Disable API call succeeded.");
            setLoadingState(null); // Clear the loading state
        }
    } catch (error) {
        if(error?.response?.data){
          setNotifMessage(`Failed to disable tracking for "${ele?.displayName}". Please try again.`);
          setInvokeNotificationToast(true);
        }
        console.error("Failed to update status:", error?.response?.data);
    } finally {
      const updatedWebsites = website.map((site) =>
        site.websiteId === ele.websiteId
          ? { ...site, isDisabled: true } // Assuming successful disable
          : site
      );
      updateWebList(updatedWebsites); // Update the state in parent
      setLoadingState(null); // Clear the loading state
  }
    // finally {
    //   updateWebList();
    // }
};


const preventScrollOutside = (event) => {
  const scrollable = scrollableRef.current;
  if (!scrollable || !scrollable.contains(event.target)) {
    event.preventDefault();
  }
};
  

  return (
    <>
     <CommonToast 
        open={invokeNotificationToast}
        onClose={handleCloseToast}
        content={notifMessage}
        bgColor="#282D51"
        fontColor="#fff"
        fontSize="14px"
        fontWeight="500"
        autoHideDuration={4000}
        iconType="error"
        marginleft = "7%"
    />
    <WarRoomHeaderForMobileResponsive websitetrack={"websitetrack"}/>
    <Box  onWheel={(e) => {preventScrollOutside(e)}} sx={{paddingTop:isUnder992px ? '20px' :  '60px', 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'flex-start',  
        textAlign: 'center', 
        width: '100%',
        height:"100vh"
        }}>
      <Box sx={{ fontWeight: 500}}>
        {/* <Typography variant="h5" sx={{ marginBottom: '48px', fontSize: '24px', textTransform: 'none',gap:'20px'}}>Track sites with ModalX 
        <Button
            sx={{
                textTransform: 'none',
                padding: '4px 8px',
                bgcolor: '#E6E0E9',
                fontSize: '12px',
                fontWeight: '500',
                color: '#17182C',
                '&:hover': {
                bgcolor: '#E6E0E9', // Keeps background color the same on hover
                color: '#17182C', // Keeps text color the same on hover
                
                },
            }}
            >
            Beta
        </Button>
        </Typography> */}
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '20px', marginBottom:isUnder992px ? '36px' : '48px',}}>

            <Typography 
             sx={{ 
              fontFamily : 'Inter',
              fontSize:isUnder992px ? '20px' : '24px',
              fontWeight: '500',
              lineHeight: '24px',
              letterSpacing: '0.10000000149011612px',
              color : '#FFFFFF',
               }}>
            Track sites with ModalX
            </Typography>
            <Button
            sx={{
                textTransform: 'none',
                padding:isUnder992px ? '2px 8px' : '4px 8px',
                bgcolor: '#E6E0E9',
                fontSize: '12px',
                fontWeight: '500',
                color: '#17182C',
                '&:hover': {
                bgcolor: '#E6E0E9', // Keeps background color the same on hover
                color: '#17182C',    // Keeps text color the same on hover
                },
            }}
            >
            Beta
            </Button>
        </Box>

        <Box sx={{ maxWidth: isUnder992px ? '90%' : '900px', minHeight: '88px', fontSize: '16px', textTransform: 'none',margin:'auto',textAlign:'start',}}>
          <Typography sx={{ marginBottom: '18px',
             textTransform: 'none',
             fontFamily : 'Inter',
             fontWeight  : 400,
             fontSize : isUnder992px ? '12px' : '16px',
             textAlign : 'center',
             color : '#FFFFFF',
              }}>
            Stay up to date with the latest updates and information on any webpage.
          </Typography>
          <Typography
           sx={{ textTransform: 'none',
                  fontFamily : 'Inter',
                  fontWeight  : 400,
                  fontSize :isUnder992px ? '12px' : '16px',
                  textAlign : 'center',
                  color : '#FFFFFF',
           }}>
            We are tracking the sites below already, but you can also add your own!  Give ModalX an URL to track, and you will get notified whenever there is an update on the site, along with a summary of the update!
          </Typography>
        </Box>
        <Box sx={{marginBottom: '40px',marginTop:isUnder992px ? '20px' :  '60px' }}>
          <Box
            sx={{
              width:isUnder992px ? '90%' : '900px',
              height: '40px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              paddingBottom: '20px',
              borderBottom: '1px solid rgba(255,255,255,0.6)',
              
              textTransform: 'none',margin:'auto'
            }}
          >
            <Typography sx={{ 
              margin: 0,
              textTransform: 'none',
              fontfontFamily : 'Inter',
              fontSize : '16px',
              fontWeight : 400,
              color : '#FFFFFF',
               
             }}>Tracked sites</Typography>
            <Button
              onClick={() =>{handleNewWebsiteAddButtonClick()}}
              sx={{
                backgroundColor: 'transparent',
                border: 'none',
                padding: 0,
                margin: 0,
                textTransform: 'none',
                color: 'rgba(255,255,255,1)',
                '&:hover': { backgroundColor: 'transparent',color:'rgba(255,255,255,0.8)' },
              }}
            >
              <AddIcon sx={{width:'20px',height:'20px',marginRight:'8px'}} />
              <Typography sx={{
                fontFamily : 'Inter',
                fontSize : '16px',
                fontWeight : 600,
                // color : '#FFFFFF',
              }}>Add website</Typography>
             
            </Button>
          </Box>
        </Box>
        {/* !openWebsiteTrackModal  && */}
        <Box ref={openWebsiteTrackModal ? null : scrollableRef} sx={{ maxHeight:isUnder992px? '40vh' : "40vh", overflowY: 'auto',maxWidth:isUnder992px ? '90%' : '900px',margin:'auto',}}>
          {website.length === 0 ? webTrackingWebsiteLoading === true? <CircularLoader  msg={"Loading websites..."} /> : <DefaultScreenIfNoWebsites /> : website.map((ele, index) => (
            <Box
              key={index}
              sx={{
                width: isUnder992px ? '100%' : '100%',
                maxWidth: isUnder992px ? '100%' : '900px',
                height: '75px',
                borderRadius: '8px',
                border: '1px solid rgba(255,255,255,0.2)',
                backgroundColor: 'transparent',
                marginBottom: '16px',
                padding: isUnder992px && '0px',
                textTransform: 'none',
                '&:hover': { backgroundColor: 'transparent' },
              }}
              // onClick={() => getSingleWebTrackDetails(ele)}
            >
              <Box sx={{ width: '100%', height: '100%', padding:  isUnder992px ? '12px' : '16px', display: 'flex',  alignItems: 'center', margin:  isUnder992px ? '0px' : ''}}>
                <Box sx={{display:"flex", gap:"16px", width: isUnder992px ? '100%' :"100%",cursor:'pointer', alignItems:"center" }} onClick={() => getSingleWebTrackDetails(ele)}>
                <Box sx={{ width: isUnder992px ? '36px' : '40px', height:  isUnder992px ? '36px' : '40px', display: 'flex', alignItems: 'center',position:'relative' }}>
                  <img src={ele?.websiteLogoUrl?.length > 0 ? ele?.websiteLogoUrl : defaultIcon} alt="website" style={{ width: isUnder992px ? '36px' : '40px', height:  isUnder992px ? '36px' : '40px',  display: 'block', border:"" }} />
                  {ele?.notificationCount > 0 && <CircleIcon sx={{ color: '#F6BE6B', width: '12px', height: '12px', position:'absolute',top:'0px' }} />}
                </Box>
                <Box sx={{ fontSize: '16px', display: 'flex', flexDirection: 'column', height: '43px', textAlign: 'start', textTransform: 'none', width:"100%", }}>
                    {ele?.displayName?.length > 0 && (
                        <Tooltip componentsProps={{
                          tooltip: {
                            sx: {
                              bgcolor: "#E6E0E9",
                              color: "#17182C",
                              fontFamily: "Inter",
                              fontSize: "12px",
                              fontWeight: 500,
                              padding: "4px 8px 4px 8px",
                              borderRadius: "4px",
                              textAlign: "left",
                            },
                          },
                        }} title={ele.displayName} placement="top">
                           
                              {
                                isUnder992px ? 
                                <Typography sx={{ marginBottom: '0px', textTransform: 'none', color: 'rgba(255,255,255,1)', bgcolor:""  }}>
                                {ele?.displayName?.length > 30 ? `${ele?.displayName.substring(0, 30)}...` : ele?.displayName}
                                {/* {ele?.displayName} */}
                                 </Typography>
                                 : 
                                <Typography sx={{ marginBottom: '0px', textTransform: 'none', color: 'rgba(255,255,255,1)' }}>
                                {ele?.displayName?.length > 40 ? `${ele?.displayName?.substring(0, 40)}...` : ele?.displayName}
                                 </Typography>
                              }
                        </Tooltip>
                    )}
                  {ele?.websiteLink?.length > 0 && (
                     <Tooltip componentsProps={{
                      tooltip: {
                        sx: {
                          bgcolor: "#E6E0E9",
                          color: "#17182C",
                          fontFamily: "Inter",
                          fontSize: "12px",
                          fontWeight: 500,
                          padding: "4px 8px 4px 8px",
                          borderRadius: "4px",
                          textAlign: "left",
                        },
                      },
                    }} title={ele.websiteLink} placement="top">
                      {
                      isUnder992px ? 
                      <Typography sx={{ fontSize: '14px', color: 'rgba(255,255,255,0.8)', textTransform: 'none' }}>
                      {ele?.websiteLink?.length > 35 ? `${ele?.websiteLink?.substring(0, 35)}...` : ele?.websiteLink}
                      </Typography>
                        : 
                        <Typography sx={{ fontSize: '14px', color: 'rgba(255,255,255,0.8)', textTransform: 'none' }}>
                      {ele?.websiteLink?.length > 50 ? `${ele?.websiteLink?.substring(0, 50)}...` : ele?.websiteLink}
                        </Typography>
                      }
                        </Tooltip>
                    
                  )}
                </Box>
                </Box>
                <Box
                    sx={{
                        maxWidth: '175px',
                        height: '14px',
                        fontSize: '12px',
                        textTransform: 'none',
                        color: 'rgba(255,255,255,1)',
                        display: 'flex',
                        alignItems: 'center', 
                        textAlign:"start",
                        justifyContent:"flex-start",
                    }}
                    >
                    {/* <Typography sx={{ textTransform: 'none', fontSize: '12px',paddingRight:ele?.notifications === false && '12px', flexShrink:isUnder992px && "0" }}>
                      {
                          isUnder992px ?  `${formatDate(ele.updatedAt)}`.substring(0, 6) : `Updated ${formatDate(ele.updatedAt)}`
                      }
                        
                    </Typography> */}
                    {/* {ele?.notifications === true && <CircleIcon sx={{ color: '#F6BE6B', width: '12px', height: '12px', marginLeft: '4px' }} />} */}
                    {!isUnder992px && (
                      <FormControlLabel
                        control={
                          <ToggleSwitch
                            sx={{ m: 1 }}
                            checked={ele?.isDisabled === false} // Controlled by updated state
                            onClick={(event) => {
                              event.preventDefault();
                              if (loadingState === ele.websiteId) return;
                              ele?.isDisabled === false ? handleDisable(ele) : handleEnable(ele);
                            }}
                            disabled={loadingState === ele.websiteId} // Disable while loading
                            key={ele?.websiteId}
                          />
                        }
                        label="Enable tracking"
                        labelPlacement="start"
                        sx={{
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          '& .MuiFormControlLabel-label': { fontSize: '14px' },
                        }}
                      />
                    )}
                </Box>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
      {/* <TrackWebsiteModal
        websites={website}
        onAddWebClicked={handleAddWebClicked}
      /> */}
    {  open && <CommonToast
         open={open}
         onClose={handleCloseToastalert}
         content={notifMessage}
         iconType={iconType}
        bgColor="#282D51"
       />}
    </Box></>
  );
};

export default WebsiteListingPage;

